export class ClientsModel {
  ClientId: number;
  ClinetName: string;
  Email: string;
  Phone: string;
  Notes: string;
  ClientTypeId: number;
  AccountHoldingTypeId: number;
  Comments: any;
  IsSendMail:boolean;
}

export class ClientTypesModel {
  ClientTypeId: number;
  Name: string;
}
export class AccountHoldingTypesModel {
  AccountHoldingTypeId: number;
  Name: string;
}
export class AccountHolderTypesModel {
  AccountHolderTypeId: number;
  Name: string;
  ClientTypeId: number;
}

export class ClientsSearchFields {
  ClientId: number;
  ClinetName: string;
  Email: string;
  Phone: string;
  Notes: string;
  ClientTypeId: number;
  AccountHoldingTypeId: number;
  PageNo: number;
  ScriptName: string;
  PageSize: number;
}

export class CountryModel {
  CountryId: number;
  Name: string;
}

export class StatesModel {
  StateId: number;
  Name: string;
  CountryId;
  CountryName: string;
  PageNo: number;
  PageSize: number;

}

export class TitlesModel {
  TitleId: number;
  Name: string;
}

export class AddressProofTypesModel {
  Name: string;
  AddressProofTypeId: number;
  Remarks: string;

}
export class NonIndvCustomerTypes {
  NonIndvCustomerTypeId: number;
  Name: string;
}

export class BankAccountTypeModel {
  BankAccountTypeId: number;
  Name: string;
}
export class AccountHolderModel {
  TitleId: number;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Title: string;
}
export class AnnualIncomesModel {
  IncomeRangeId: number;
  Value: string;
}

export class SettlementOfFundsModel {
  SettlementFundsId: number;
  Name: string;
}
export class AccountTypesModel {
  AccountTypeId: Number;
  Name: string;
}


export class NomineeModel {
  NomineeId: number;
  ClientId: number;
  OrderId: number;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Share: number;
  ApplicantRelationship: string;
  StateId: number;
  CountryId: number;
}
export class ClientUserModel {
  ClientId: number;
  ClinetName: string;
  Email: string;
  Phone: string;
  Notes: string;
  ClientTypeId: number;
  AccountHoldingTypeId: number;
  UniqueRandomId: string;
  UserName: string;
  Password: string;
}


export class FormFilledData {
  ClientId: number;
  Value: number;
}
export class IntroducerStatusTypes {
  Name: string;
  IntroducerStatusId: Number;
}
